import type { Slice } from "utils/helpers/Query/splitSQLQuery";

import { StatementLocation } from "pages/DevelopWorkspace/workspace.types";

/**
 * Computes absolute location for a query statement extracted from a selection or full document.
 *
 * Inputs are 1-based `baseLineNumber` (the line where the selection starts),
 * absolute `selectionOffset` (the character offset in the full document where the selection starts),
 * and a `query` Slice whose `pos` and `lineNumber` are relative to the provided text slice.
 *
 * - Absolute start/end are `selectionOffset + query.pos[0/1]` because `pos` is selection-relative.
 * - Absolute line number adjusts the 1-based base by the 1-based relative shift of the statement:
 *   `absolute = baseLineNumber + (query.lineNumber - 1)`.
 */
export function getQueryStatementLocation(
  baseLineNumber: number,
  selectionOffset: number,
  query: Slice
): StatementLocation {
  const start = selectionOffset + query.pos[0];
  const end = selectionOffset + query.pos[1];
  const lineNumber = baseLineNumber + (query.lineNumber - 1);
  return { lineNumber, start, end };
}
